var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 11.2788V13.2788C14.6675 13.4644 14.6294 13.6482 14.555 13.8183C14.4807 13.9884 14.3716 14.1412 14.2348 14.2667C14.0979 14.3922 13.9364 14.4878 13.7605 14.5472C13.5847 14.6067 13.3983 14.6288 13.2134 14.6121C11.1619 14.3892 9.19137 13.6882 7.46004 12.5654C5.84926 11.5419 4.48359 10.1762 3.46004 8.56543C2.33336 6.82623 1.6322 4.84609 1.41337 2.78543C1.39671 2.60107 1.41862 2.41527 1.4777 2.23985C1.53679 2.06442 1.63175 1.90322 1.75655 1.76651C1.88134 1.6298 2.03324 1.52057 2.20256 1.44578C2.37189 1.37099 2.55493 1.33227 2.74004 1.3321H4.74004C5.06357 1.32891 5.37723 1.44348 5.62254 1.65445C5.86786 1.86542 6.02809 2.15839 6.07337 2.47876C6.15779 3.11881 6.31434 3.74725 6.54004 4.3521C6.62973 4.59071 6.64915 4.85004 6.59597 5.09935C6.5428 5.34866 6.41928 5.5775 6.24004 5.75876L5.39337 6.60543C6.34241 8.27446 7.72434 9.65639 9.39337 10.6054L10.24 9.75876C10.4213 9.57952 10.6501 9.456 10.8994 9.40283C11.1488 9.34965 11.4081 9.36907 11.6467 9.45876C12.2516 9.68446 12.88 9.84101 13.52 9.92543C13.8439 9.97112 14.1396 10.1342 14.3511 10.3838C14.5625 10.6333 14.6748 10.9518 14.6667 11.2788Z",
    stroke: "#7C21FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.000230f1c020093abc3494fce084b319.svg";
export { ForwardRef as ReactComponent };